<template>
  <div class="season cricket-stats">
    <loading-state :state="state"></loading-state>
    <div v-if="team">
      <h2>{{team.name}} - {{team.season.card_name}}</h2>
      <cricket-season-menu :showSeason="true" :seasonKey="seasonKey" :isMetric="isMetric ? true : false"></cricket-season-menu>

      <div>
        <router-link :to="{name:'cricketTeam', params: {key: team.teamkey}}">
          {{team.name}} Stats
        </router-link>
      </div>
      <div v-if="team.players_key.length > 0">
        <section
          v-for="role in teamPlayersByRole"
          v-if="role.players.length"
          :key="role.name">
          <h3>{{role.name}}</h3>
          <div class="sub-content">
            <div
              class="item link compact"
              v-for="playerKey in role.players" :key="playerKey">
              <router-link class="clean no-top-left"
               :to="{name: 'cricketPlayer', params:{key: playerKey}}">
                {{team.players[playerKey].full_name}}
              </router-link>
              <span
                :class="{
                  'changing': team.players[playerKey].isValidSeasonRole,
                  'alert': !team.players[playerKey].isValidSeasonRole}"
                v-if="team.players[playerKey].isSeasonalRoleDifferent"
              >(seasonal {{team.players[playerKey].seasonal_role}})</span>
              <div class="silent">Card name: {{team.players[playerKey].name}}</div>
              <div class="silent"  
                v-if="team.players[playerKey].batting_style && team.players[playerKey].batting_style.length">Bat: {{team.players[playerKey].batting_style | join}}</div>
              <div class="silent"  
                v-if="team.players[playerKey].bowling_style && team.players[playerKey].bowling_style.length">Bowl: {{team.players[playerKey].bowling_style | join}}</div>
            </div>
          </div>
        </section>
      </div>
      <div v-else>
        <div class="center">
          <p>Team info not available</p>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import { CricketSeason } from '@/models/cricket/season'
import { CricketPlayerRoleOrder } from '@/models/cricket/player'
import { DataState, AppState } from '@/state'
import Utils from '@/utils'

export default {
  name: 'seasonTeam',
  props: {
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      seasonKey: this.$route.params.key,
      teamKey: this.$route.params.teamkey,
      team: null,
      teamPlayersByRole: [],
      state: DataState.newLoading(),
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key || to.params.teamkey !== from.params.teamkey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      this.teamKey = this.$route.params.teamkey
      const newTitle = 'loading...'
      AppState.updateActivePage(`cricket_season_${this.seasonKey}_team_${this.teamKey}`)
      AppState.updateTitles(newTitle, newTitle)

      CricketSeason.team(this.seasonKey, this.teamKey, this.isMetric).then(team => {
        this.team = team

        //TODO: This should come from API
        this.team.teamkey = this.team.card_name.toLowerCase()

        this.preparePlayersByRole()
        const newTitle = `${team.name} Team`
        AppState.updateTitles(newTitle, newTitle)

        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    preparePlayersByRole () {
      let playerRoles = []
      let roleMap = {}
      const playerList = this.team.players_key

      CricketPlayerRoleOrder.forEach((role, index) => {
        playerRoles.push({ name: role.name, players: [] })
        if (role.keys === null) {
          roleMap['others'] = index
        } else if (role.keys === 'not_found') {
          roleMap['not_found'] = index
        } else {
          role.keys.forEach((key) => { roleMap[key] = index })
        }
      })

      playerList.forEach((playerKey) => {
        const player = this.team.players[playerKey]
        let role = player.role
        let index = roleMap['others']
        if (role && roleMap.hasOwnProperty(role.key)) {
          index = roleMap[role.key]
        }
        playerRoles[index].players.push(player.key)
      })

      this.teamPlayersByRole = playerRoles
    },

    prepareToReopen () {
      this.seasonKey = null
      this.teamKey = null
      this.teamPlayersByRole = []
      this.stats = null
    },
    refreshView () {

    },
  }
}
</script>
